<template>
  <layout-dashboard>
    <div class="row">
      <div class="col-md-12">
        <nav class="navbar navbar-expand p-0">
          <div class="navbar-nav mr-auto">
            <h4 class="mb-0">Métodos de retiro</h4>
          </div>
          <div
            class="navbar-nav flex-row-reverse ml-md-auto align-self-md-end pl-1"
          >
            <router-link to="/withdrawal-methods/edit" class="btn btn-primary">
              <i class="fas fa-plus"></i>
              <span class="ml-1">Agregar</span>
            </router-link>
          </div>
        </nav>
      </div>
      <div class="col-md-12">
        <div class="withdrawal-tab">
          <div class="tab-content">
            <!-- Withdrawal Tab -->
            <div class="tab-pane show active">
              <div class="card card-table mb-0">
                <div class="card-body">
                  <div class>
                    <table
                      id="table-withdrawal"
                      class="table table-hover table-center responsive w-100 mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Tipo de Comisión</th>
                          <th>Monto</th>
                          <th class="no-sort"></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Withdrawal Tab -->
          </div>
        </div>
      </div>
    </div>
  </layout-dashboard>
</template>

<script>
import { EventBus } from "@/main";
import global from "@/helpers/global";
import table from "@/helpers/table";

export default {
  data() {
    return {
      withdrawal_methods: [],
      dataTable: null,
      tableFields: ["name", "commission_type.display_name", "commission"],
      errors: [],
    };
  },
  mixins: [global, table],
  beforeMount() {},
  mounted() {
    this.dataTable = this.initializeTable("#table-withdrawal");

    axios
      .get(process.env.VUE_APP_API_URL + "/api/v1/withdrawal-way/list")
      .then((response) => {
        this.withdrawal_methods = response.data.withdrawal_ways;
      })
      .catch((error) => {
        this.errors = [];
        this.errors = error.response.data.errors ?? [];
        console.log(error.response.data.message);
      })
      .finally(() => {
        this.generateTableWithData(this.withdrawal_methods, this.tableFields);

        //this.renderTable();

        var _self = this;

        $("#table-withdrawal").on("click", ".action-enable", function() {
          $("#table-withdrawal tr.selected").removeClass("selected");
          $(this)
            .closest("tr")
            .addClass("selected");

          _self.enable($(this).attr("attr_id"));
        });

        $("#table-withdrawal").on("click", ".action-disable", function() {
          $("#table-withdrawal tr.selected").removeClass("selected");
          $(this)
            .closest("tr")
            .addClass("selected");

          _self.disable($(this).attr("attr_id"));
        });

        console.log("Component mounted.");
      });
  },
  methods: {
    enable(id) {
      axios
        .get(
          process.env.VUE_APP_API_URL + "/api/v1/withdrawal-way/enable/" + id
        )
        .then((response) => {
          let index = this.withdrawal_methods.findIndex((x) => x.id == id);

          this.withdrawal_methods[index].active = 1;

          this.updateRowTable(this.withdrawal_methods[index]);

          EventBus.$emit("showInfo", {
            msg: response.data.message,
          });

          console.log(response.data.message);
        })
        .catch((error) => {
          this.errors = [];
          this.errors = error.response.data.errors ?? [];

          EventBus.$emit("showErrors", {
            msg: error.response.data.error,
          });

          console.log(error.response.data.error);
        });
    },
    disable(id) {
      axios
        .get(
          process.env.VUE_APP_API_URL + "/api/v1/withdrawal-way/disable/" + id
        )
        .then((response) => {
          let index = this.withdrawal_methods.findIndex((x) => x.id == id);

          this.withdrawal_methods[index].active = 0;

          this.updateRowTable(this.withdrawal_methods[index]);

          EventBus.$emit("showInfo", {
            msg: response.data.message,
          });

          console.log(response.data.message);
        })
        .catch((error) => {
          this.errors = [];
          this.errors = error.response.data.errors ?? [];

          EventBus.$emit("showErrors", {
            msg: error.response.data.error,
          });

          console.log(error.response.data.error);
        });
    },
    tableActions: function(id) {
      let withdrawal_method = this._clone(
        this.withdrawal_methods.filter(function(p) {
          return p.id == id;
        })[0]
      );

      let actions = '<div class="table-action">';

      if (withdrawal_method.active == 0) {
        actions +=
          `
                      <a href="javascript:void(0);" attr_id="` +
          id +
          `" class="btn btn-sm bg-success-light action-enable">
                        <i class="fas fa-check"></i> Activar
                      </a>`;
      } else {
        actions +=
          `
                      <a href="javascript:void(0);" attr_id="` +
          id +
          `" class="btn btn-sm bg-danger-light action-disable">
                        <i class="fas fa-times"></i> Desactivar
                      </a>`;
      }

      actions +=
        `<a href="` +
        this.$router.resolve({
          name: "withdrawal-methods-edit",
          params: { id: id },
        }).href +
        `" class="btn btn-sm bg-warning-light">
                        <i class="far fa-edit"></i> Editar
                      </a>`;

      actions += "</div>";

      return actions;
    },
  },
};
</script>
